import { WPHousePost } from '../types/wp-data';

declare global {
	interface Window {
// eslint-disable-next-line @typescript-eslint/no-explicit-any
		dataLayer: any[];
	}
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let previousCartContents: any|null = null;

export function enhancedEcommerceAddToCart( post: WPHousePost ): void {
	const newCartContents = {
		brand: 'theAddresses',
		category: 'House',
		id: 'theaddresses_' + post.id,
		name: post.title,
		quantity: 1,
	};

	if ( previousCartContents ) {
		window.dataLayer.push( {
			event: 'removeFromCart',
			ga: {
				event: {
					category: 'Ecommerce',
					action: 'Remove From Cart',
				},
			},
			ecommerce: {
				currencyCode: 'EUR',
				add: {
					products: [
						previousCartContents,
					],
				},
				impressions: undefined,
				promoView: undefined,
			},
		} );
	}

	previousCartContents = newCartContents;

	window.dataLayer.push( {
		event: 'addToCart',
		ga: {
			event: {
				category: 'Ecommerce',
				action: 'Add To Cart',
			},
		},
		ecommerce: {
			currencyCode: 'EUR',
			add: {
				products: [
					newCartContents,
				],
			},
			impressions: undefined,
			promoView: undefined,
		},
	} );
}

export function enhancedEcommerceCheckout( postId: number, postTitle: string, totalCostInCents: number ): void {
	window.dataLayer.push( {
		event: 'completeCheckout',
		ecommerce: {
			purchase: {
				actionField: {
					id: `${( new Date() ).toISOString()}-${Math.random()}`.slice( 0, 35 ),
					revenue: Math.round( totalCostInCents / 100 ),
				},
				products: [
					{
						brand: 'theAddresses',
						category: 'House',
						id: 'theaddresses_' + postId,
						name: postTitle,
						quantity: 1,
						price: Math.round( totalCostInCents / 100 ),
					},
				],
			},
		},
	} );
}
